import { Collection, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractItem from './abstractItem';
import ItemInterface from './itemInterface';

namespace('Ofcs.Editor.Item');

/**
 * @class ItemCollection
 * @extends Collection
 */
export default window.Ofcs.Editor.Item.ItemCollection = Collection.extend({
    model: AbstractItem,

    initialize() {
        Collection.prototype.initialize.call(this);
        this.on('remove', item => item.trigger('delete', item), this);
    },

    /**
     * Add an item
     *
     * @param {ItemInterface|Array<ItemInterface>} item Item
     * @param {Object} options Options
     *
     * @return {ItemCollection} this
     *
     * @chainable
     */
    add(item, options = null) {
        const items = Array.isArray(item) ? item.slice() : [item];

        for (let i = 0; i < items.length; i += 1) {
            ItemInterface.assert(items[i]);
        }

        return Collection.prototype.add.call(this, item, options);
    },

    /**
     * Calculate bounds object of all items.
     *
     * @return {Bounds}
     */
    getBounds() {
        let bounds = null;

        this.each((item) => {
            if (bounds) {
                bounds = bounds.merge(item.getBounds());
            } else {
                bounds = item.getBounds().clone();
            }
        });

        return bounds;
    },

    /**
     * Calculate bounds object of all items.
     *
     * @return {Bounds}
     */
    getAbsoluteBounds() {
        let bounds = null;

        this.each((item) => {
            const itemBounds = item.getAbsoluteBounds();

            if (bounds) {
                bounds.extend(itemBounds.topLeft).extend(itemBounds.bottomRight);
            } else {
                bounds = itemBounds.clone();
            }
        });

        return bounds;
    },

    /**
     * Calculate margin bounds object of all items.
     *
     * @return {Bounds}
     */
    getMarginBounds() {
        let bounds = null;

        this.each((item) => {
            const itemBounds = item.getMarginBounds();

            if (bounds) {
                bounds.extend(itemBounds.topLeft).extend(itemBounds.bottomRight);
            } else {
                bounds = itemBounds.clone();
            }
        });

        return bounds;
    },

    /**
     * Returns the count of all items.
     *
     * @return {number}
     */
    getItemCount() {
        return this.size();
    },
});
